import _export from '../internals/export.js';
import fails$1 from '../internals/fails.js';
import toIndexedObject$1 from '../internals/to-indexed-object.js';
import '../internals/object-get-own-property-descriptor.js';
import descriptors from '../internals/descriptors.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var fails = fails$1;
var toIndexedObject = toIndexedObject$1;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var DESCRIPTORS = descriptors;
var FAILS_ON_PRIMITIVES = fails(function () {
  nativeGetOwnPropertyDescriptor(1);
});
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

$({
  target: 'Object',
  stat: true,
  forced: FORCED,
  sham: !DESCRIPTORS
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});
